export default "__VITE_ASSET__DKjv5324__"